var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scrolled__last-fixed":
          _vm.isScrolled && _vm.fixedColumn === "last",
        "c-table_scrolled__first-fixed":
          _vm.isScrolled && _vm.fixedColumn === "first",
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
        "c-table_edit-modal-is-active": _vm.editModalIsActive,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          "reference-list": _vm.referenceList,
          "active-filters": _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.data.records.length !== 0 &&
      _vm.fixedColumn === "last" &&
      !_vm.editModalIsActive
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.records.length === 0
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper",
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c("table", { ref: "container", staticClass: "c-table__container" }, [
            _c(
              "thead",
              { ref: "header", staticClass: "c-table__header" },
              _vm._l(_vm.levels, function (i) {
                return _c(
                  "tr",
                  { key: i, staticClass: "c-table__header-row" },
                  [
                    _vm._l(
                      _vm.getTableColumns(i),
                      function (column, columnIndex) {
                        return _c(
                          "th",
                          {
                            key: column.id,
                            staticClass: "c-table__column",
                            class: {
                              "c-table__column_with_filter": column.type,
                              "c-table__column_hidden": _vm.isDisabled(
                                column.id
                              ),
                              "c-table__column_sorted": _vm.isSorted(column),
                              "sticky-column sticky-column__first":
                                _vm.fixedColumn === "first" &&
                                columnIndex === 0,
                              "sticky-column__first-shadow-active":
                                _vm.fixedColumn === "first" &&
                                columnIndex === 0 &&
                                _vm.isScrolled,
                            },
                            attrs: {
                              id: `c-table-column-${column.id}`,
                              colspan: _vm.getColspan(column),
                              rowspan: _vm.getRowspan(column),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-table__column-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "c-table__column-label",
                                    class: {
                                      "c-table__column-label-children":
                                        !_vm.isCategory(column) &&
                                        _vm.sortedColumn,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setSortedColumn(
                                          column,
                                          _vm.sortedColumn
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(column.label) + " ")]
                                ),
                                column.description || column.type
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "c-table__column-actions",
                                      },
                                      [
                                        column.fullName
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action c-table__column-action_description",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-description-${column.id}`,
                                                    size: "small",
                                                    icon: "info",
                                                    "no-border": "",
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-description-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          column.fullName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.isColumnFiltered(column.id)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-filter-${column.id}`,
                                                    size: "small",
                                                    "no-border": "",
                                                    active:
                                                      _vm.isColumnActiveFiltered(
                                                        column.id
                                                      ),
                                                    icon: {
                                                      icon: "filter-column",
                                                      activeColor: "blue",
                                                    },
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openColumnFilterModal(
                                                        column
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-filter-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.isColumnActiveFiltered(
                                                            column.id
                                                          )
                                                            ? "Изменить фильтр"
                                                            : "Применить фильтр"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }
                    ),
                    _vm.data.actions && i === 1
                      ? _c(
                          "th",
                          {
                            staticClass:
                              "c-table__column c-table__column_actions",
                            class: {
                              "sticky-column sticky-column__last":
                                _vm.fixedColumn === "last",
                            },
                            attrs: { rowspan: _vm.levels },
                          },
                          [_c("div", { staticClass: "c-table__column-empty" })]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _c(
              "tbody",
              { staticClass: "c-table__records" },
              _vm._l(_vm.data.records, function (record, recordIndex) {
                return _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: record.isShowRow,
                        expression: "record.isShowRow",
                      },
                    ],
                    key: recordIndex,
                    staticClass: "c-table__record",
                    class: {
                      "c-table__summary-record": record.id === "summary_record",
                      "c-table__red": _vm.shouldRowBeRed(record),
                      "c-table__blue": _vm.shouldRowBeBlue(record),
                    },
                  },
                  [
                    _vm._l(
                      _vm.getTableColumns(_vm.levels, true),
                      function (column, columnIndex) {
                        return _c(
                          "td",
                          {
                            key: column.id,
                            staticClass: "c-table__cell",
                            class: {
                              "c-table__cell_string": column.type === "string",
                              "c-table__cell_reference":
                                column.type === "reference",
                              "c-table__cell_number": column.type === "number",
                              "c-table__cell_date": column.type === "date",
                              "c-table__cell_hidden": _vm.isDisabled(column.id),
                              "sticky-column sticky-column__first":
                                _vm.fixedColumn === "first" &&
                                columnIndex === 0,
                              "sticky-column__first-shadow-active":
                                _vm.fixedColumn === "first" &&
                                columnIndex === 0 &&
                                _vm.isScrolled,
                              ["c-table__cell_" + column.id]: column.id,
                              [`c-table__cell__data__${_vm.data.type}`]:
                                _vm.data.type,
                            },
                            attrs: {
                              "data-cell":
                                record[column.id] && record[column.id].class,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleClick(record, column)
                              },
                            },
                          },
                          [
                            _vm.isDefaultCell(record, column)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "c-table__cell-value",
                                    class: {
                                      "c-table__cell-pre-formatted":
                                        column.id === "postCategorySpecialty" &&
                                        !_vm.isCandidatesTableType,
                                      "w-250": column.id === "address",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(record[column.id].value)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm.isCustomCellDataType &&
                            !_vm.isDefaultCell(record, column)
                              ? _c("c-table-cell", {
                                  staticClass: "c-table__cell-cell",
                                  attrs: {
                                    cell: _vm.getCustomCellId(
                                      record[column.id]
                                    ),
                                    data: record[column.id],
                                  },
                                })
                              : _vm._e(),
                            record[column.id] && record[column.id].employee
                              ? _c("c-table-cell", {
                                  staticClass: "c-table__cell-cell",
                                  attrs: {
                                    cell: "employee",
                                    data: record[column.id].employee,
                                  },
                                })
                              : _vm._e(),
                            record[column.id] && record[column.id].depositState
                              ? _c("c-table-cell", {
                                  staticClass: "c-table__cell-cell",
                                  attrs: {
                                    cell: "deposit-state",
                                    data: record[column.id].depositState,
                                  },
                                })
                              : _vm._e(),
                            column.id === "worker_author" ||
                            column.id === "author" ||
                            column.id === "update_author" ||
                            column.id === "delete_author"
                              ? _c(
                                  "div",
                                  { staticClass: "c-table__cell-value" },
                                  [
                                    _c("worker-or-user", {
                                      attrs: { value: record[column.id] },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                    _vm.data.actions
                      ? _c(
                          "td",
                          {
                            staticClass: "c-table__cell c-table__cell_actions",
                            class: {
                              "sticky-column sticky-column__last":
                                _vm.fixedColumn === "last",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "c-table__cell-actions",
                                class: {
                                  [`c-table__cell__data__${_vm.data.type}`]:
                                    _vm.data.type,
                                },
                              },
                              [
                                _vm.data.type === "employees"
                                  ? _c("c-table-actions", {
                                      attrs: {
                                        type: _vm.data.type,
                                        record: record,
                                        "record-index": recordIndex,
                                        "record-count": _vm.data.records.length,
                                      },
                                      on: {
                                        "disable-show-row":
                                          _vm.disableRecordShow,
                                        "edit-worker": function ($event) {
                                          return _vm.$emit(
                                            "edit-worker",
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.data.type === "calculations"
                                  ? _c("c-table-actions", {
                                      attrs: {
                                        type: _vm.data.type,
                                        record: record,
                                        canAllDelete: _vm.canAllDelete,
                                        canDeleteFiilals: _vm.canDeleteFiilals,
                                        "record-index": recordIndex,
                                        "record-count": _vm.data.records.length,
                                      },
                                      on: {
                                        "disable-show-row":
                                          _vm.disableRecordShow,
                                      },
                                    })
                                  : _vm._e(),
                                _vm.data.type === "candidates"
                                  ? _c("candidates-actions-cell", {
                                      attrs: {
                                        type: _vm.data.type,
                                        record: record,
                                        "record-index": recordIndex,
                                        "record-count": _vm.data.records.length,
                                      },
                                    })
                                  : _vm._e(),
                                _vm.data.type === "violations"
                                  ? _c("violations-actions-cell", {
                                      attrs: {
                                        record: record,
                                        "record-index": recordIndex,
                                      },
                                      on: {
                                        addExplanatory: function ($event) {
                                          return _vm.$emit(
                                            "addExplanatory",
                                            $event
                                          )
                                        },
                                        viewExplanatory: function ($event) {
                                          return _vm.$emit(
                                            "viewExplanatory",
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.data.type === "finesAndBonuses"
                                  ? _c("fine-and-bonuses-actions-cell", {
                                      attrs: {
                                        record: record,
                                        "record-index": recordIndex,
                                      },
                                      on: {
                                        addExplanatory: function ($event) {
                                          return _vm.$emit(
                                            "addExplanatory",
                                            $event
                                          )
                                        },
                                        viewExplanatory: function ($event) {
                                          return _vm.$emit(
                                            "viewExplanatory",
                                            $event
                                          )
                                        },
                                        openedEditModal: _vm.openedEditModal,
                                        closedEditModal: _vm.closedEditModal,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }